<template>
    <div :class="'relative ' + wrapperCssClasses">
        <label
            v-if="label && labelPosition == 'top'"
            :for="id"
            :class="'block text-base font-semibold ' + labelClasses"
        >
            <span v-html="label"></span>
        </label>

        <div class="relative flex items-center">
            <label
                v-if="label && labelPosition == 'inside' && modelValue"
                :for="id"
                :class="
                    'text-gray-1700 absolute left-4 top-2 z-20 text-[12px] ' +
                    labelClasses
                "
            >
                <span v-html="label"></span>
            </label>

            <input
                :id="id"
                :name="name"
                :ref="id"
                :class="
                    themedCssClasses +
                    (disabled
                        ? ' cursor-not-allowed border-gray-400 bg-gray-50 text-gray-500'
                        : '') +
                    ($page.props.errors[name] ? ' border-red-400' : '')
                "
                type="text"
                :value="modelValue"
                @input="updateInput"
                :disabled="disabled"
                :required="required"
                :placeholder="this.placeholder ?? this.label"
            />

            <svg
                class="top-50% absolute left-3"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.0833 17.4167C14.1334 17.4167 17.4167 14.1334 17.4167 10.0833C17.4167 6.03325 14.1334 2.75 10.0833 2.75C6.03325 2.75 2.75 6.03325 2.75 10.0833C2.75 14.1334 6.03325 17.4167 10.0833 17.4167Z"
                    stroke="#84929A"
                    stroke-width="1.83333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M19.2499 19.2492L15.2624 15.2617"
                    stroke="#84929A"
                    stroke-width="1.83333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>

            <svg
                v-if="modelValue"
                v-on:click="
                    modelValue = '';
                    $emit('update:modelValue', '');
                "
                class="absolute right-3 top-3 hover:cursor-pointer"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_1701_2083)">
                    <path
                        d="M11.0004 20.1654C16.063 20.1654 20.1671 16.0613 20.1671 10.9987C20.1671 5.93609 16.063 1.83203 11.0004 1.83203C5.9378 1.83203 1.83374 5.93609 1.83374 10.9987C1.83374 16.0613 5.9378 20.1654 11.0004 20.1654Z"
                        stroke="#84929A"
                        stroke-width="1.83333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M13.75 8.25L8.25 13.75"
                        stroke="#84929A"
                        stroke-width="1.83333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M8.25 8.25L13.75 13.75"
                        stroke="#84929A"
                        stroke-width="1.83333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1701_2083">
                        <rect width="22" height="22" fill="white"/>
                    </clipPath>
                </defs>
            </svg>

            <form-error-warning-triangle name="name" position-css="right-2"/>
        </div>

        <div class="text-[16px] text-gray-700" v-if="hint">
            {{ hint }}
        </div>

        <field-error :field-name="name" :message="$page.props.errors[name]"/>
    </div>
</template>

<script>
import FieldError from "@/Components/FieldError";
import FormErrorWarningTriangle from "@/Components/FormErrorWarningTriangle";

export default {
    name: "FormInput",
    components: {
        FieldError,
        FormErrorWarningTriangle,
    },
    props: {
        id: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        labelPosition: {
            type: String,
            default: "top",
        },
        hint: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        modelValue: {
            type: [String, Number],
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        theme: {
            type: String,
            default: "bright",
        },
        wrapperCssClasses: {
            type: String,
            default: "mb-4",
        },
        labelClasses: {
            type: String,
            default: "block text-base",
        },
        cssClasses: {
            type: String,
            default: "",
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        updateInput(event) {
            this.$emit("update:modelValue", event.target.value);
        },
    },
    mounted() {
        if (this.autofocus) {
            // document.getElementById(this.id).focus();
        }
    },
    computed: {
        themedCssClasses() {
            let css = this.theme + " appearance-none ";

            if (this.labelPosition == "inside") {
                css += "w-full pl-12 p-1 pl-3 pt-6 ";
            } else {
                css += "w-full pl-12 p-2 ";
            }

            css += " " + this.cssClasses;

            return css;
        },
    },
};
</script>
